module.exports = __webpack_public_path__ + "assets/droplet-video.2df2bd1d.svg";